import React from 'react';
import {Subscriptions} from 'api';
import {toastr} from 'react-redux-toastr';
import _NewsLetterRegister from './_NewsLetterRegister.scss';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import isEmpty from 'lodash/isEmpty';

class NewsLetterRegister extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: '',
      toggle: false,
      isSubmit: false
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.togglePlaceholder = this.togglePlaceholder.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (!isEmpty(this.state.email)) {
      const data = {
        email: this.state.email
      };
      this.setState({isSubmit: true});
      Subscriptions.actions.send.request({}, {data}).then((response) => {
        this.setState({isSubmit: false, email: ''});
        toastr.success('Thành công!', 'Đã đăng ký nhận tin thành công.');
      }).catch((error) => {
        this.setState({isSubmit: false});
        toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      });
    }
  }

  togglePlaceholder() {
    this.setState({toggle: !this.state.toggle});
  }

  render() {
    const {isSubmit, toggle, email} = this.state;
    return (
      <form className="wrap-news-letter-register" onSubmit={this.onSubmit}>
        <div className='wrap-img'>
          <img className='news-letter-img' src={require('assets/images/partials/dang-ki-nhan-tin.svg')} alt=''/>
        </div>
        <div className='wrap-title'>
          <h3 className='title-black'>Đăng kí nhận tin</h3>
          <p className='news-letter-description'></p>
        </div>
        <div className={toggle || email !== '' ? 'wrap-input has-value' : 'wrap-input'}>
          <input className='news-letter-input' name="email" onBlur={this.togglePlaceholder} onFocus={this.togglePlaceholder} value={email} onChange={this.onChange}/>
          <label className='label-for-title'>Email của bạn</label>
        </div>
        <LaddaButton className="news-letter-button" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Đăng ký</LaddaButton>
      </form>
    );
  }
}

export default NewsLetterRegister;



// WEBPACK FOOTER //
// ./components/home/sub-view/NewsLetterRegister.jsx